import { useTranslation } from "react-i18next";
import capitalize from "lodash/capitalize";
const useGranteeTypeLabel = () => {
  const { t, i18n } = useTranslation("users");
  return (type) => i18n.exists(`permissions.grantee_types.${type}`, { ns: "users" }) ? t(`permissions.grantee_types.${type}`) : capitalize(type);
};
export default useGranteeTypeLabel;
